<script setup>
import { useForm } from '@inertiajs/inertia-vue3';
import { ref } from 'vue';

import CreateUser from '@/Pages/Users/Create.vue';

const form = useForm({
    email: '',
    name: '',
	user_type: props.user_type,
	permissions: null,
})

const props = defineProps({
    errors: {
        type: Object,
        default: () => ({}),
    },
	organisation: {
		type: Object,
		required: false,
	},
	user_type: {
		type: String,
		default: 'user',
	},
})

const userPermissions = ref(null)
const roles= ref([])

function createUser() {
    form.transform((data) => {
		data.permissions = userPermissions.value
		return data
	}).post('/users')
}

function setPermissions(permissions) {
	userPermissions.value = permissions
}
</script>

<template>
	<CreateUser
		:user="form"
		:errors="errors"
		:roles="roles"
		:organisation="organisation"
		@create:users="createUser"
		@set-permissions="setPermissions"
	/>
</template>